import * as React from 'react';

import { ColorPalette } from '@acceligentllc/shared/enums/color';

import BarMeter from 'af-components/BarMeter';

interface OwnProps {
	daysAssigned: number;
	daysAvailable: number;
	daysUnavailable: number;
	totalDays: number;
}
type Props = OwnProps;

const WorkingCell = (props: Props) => {
	const { daysAssigned, daysAvailable, daysUnavailable, totalDays } = props;

	const workingPercentage = Math.round(daysAssigned / (totalDays || 1) * 100);
	let color: ColorPalette = ColorPalette.GREEN;
	if (workingPercentage < 25) {
		color = ColorPalette.RED;
	} else if (workingPercentage < 67) {
		color = ColorPalette.ORANGE;
	}

	const entries = [
		{ label: 'Scheduled', value: daysAssigned, color: color },
		{ label: 'Not Scheduled', value: daysAvailable, isHidden: true },
		{ label: 'Not Available', value: daysUnavailable, isHidden: true },
	];
	return (
		<div className="working">
			<span>{workingPercentage}% ({daysAssigned} days)</span>
			<BarMeter entries={entries} total={totalDays} unitLabel="days" withTooltip={true} />
		</div>
	);
};

export default React.memo(WorkingCell);
